import axios from "@/axios";

const actions = {
    async fetchMessage(_, messageId) {
        try {
            const response = await axios.get(`/message/${messageId}`);
            return(response.data.message);
        } catch (error) {
            console.error('Error fetching message:', error);
        }
    },
};

export default {
    namespaced: true,
    actions,
};